export const getInitials = (name: string): string => {
  const TITLES = new Set([
    // English titles
    'dr',
    'sir',
    'madam',
    'lady',
    'lord',
    'rev',
    'fr',
    'hon',
    'dame',
    'pres',
    'gen',
    'lt',
    'capt',

    // German titles
    'dr',
    'prof',
    'dipl',
    'dipl-ing',
    'ing',
    'dir',
    'mag',
    'lic',
    'bsc',
    'msc',
    'mba',
    'ba',
    'jur',
    'med',
    'phil',
    'rer',
    'pol',
    'hons',
    'hc',
    'sen',
    'kfm',
    'oec',
    'techn',
    'vet',
  ]);

  const PARTICLES = new Set([
    // International
    'von',
    'van',
    'de',
    'del',
    'della',
    'di',
    'da',
    'du',
    'le',
    'la',
    'el',
    'al',
    'bin',
    'ibn',
    'ap',
    'mac',
    'mc',

    // German-specific
    'zu',
    'zur',
    'zum',
    'und',
    'der',
    'den',
    'dem',
    'des',
    'im',
    'am',
    'an',
  ]);

  const nameParts = name
    .split(/\s+/)
    .map((word) => word.trim())
    .filter((word) => word.length > 0)
    .filter((word) => {
      const normalized = word.toLowerCase().replace(/\./g, '');
      return !TITLES.has(normalized) && !PARTICLES.has(normalized);
    });
  if (nameParts.length === 0) {
    return '';
  }
  const firstName = nameParts[0] ?? '';
  const initials = (firstName[0] ?? '').toUpperCase();
  if (nameParts.length > 1) {
    const lastName = nameParts[nameParts.length - 1] ?? '';
    return initials + (lastName[0] ?? '').toUpperCase();
  }
  return initials;
};
